import Keyboard1 from "./Keyboard1";
import HomeIndicator from "./HomeIndicator";
import PropTypes from "prop-types";

const Footer = ({ className = "" }) => {
  return (
    <div
      className={`flex flex-col items-start justify-start relative max-w-full text-center text-sm text-light-primary-key-background font-text-regular-lowercase ${className}`}
    >
      <div className="w-[321px] !m-[0] absolute top-[39px] left-[60px] flex flex-row items-start justify-start max-w-full">
        <div className="h-10 w-[360px] absolute !m-[0] bottom-[-12px] left-[-20px] rounded-t-none rounded-b-xl bg-dark-orange" />
        <div className="flex-1 relative leading-[120%] inline-block max-w-full z-[1]">
          Chưa thanh toán dịch vụ, free năm đầu tiên
        </div>
      </div>
      <div className="absolute !m-[0] top-[108px] left-[138px] text-base font-medium text-light-text whitespace-pre-wrap">
        + Thêm thiết bị mới
      </div>
      <Keyboard1
        appearance="Light"
        hIndicator
        suggestions={false}
        type="Alphanumeric"
      />
      <HomeIndicator
        homeIndicatorBackgroundColor="unset"
        homeIndicatorMargin="0 !important"
        homeIndicatorPosition="absolute"
        homeIndicatorRight="0px"
        homeIndicatorBottom="0px"
        homeIndicatorLeft="0px"
        homeIndicatorTop="unset"
        homeIndicatorMarginTop="unset"
      />
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default Footer;
